export const WIDGET_NAME = 'membership_ancillaries';
export const OFFER_ZERO = 0;
export const OFFER_TYPES = {
    FULL_FARE: 'FULL_FARE',
    PRIME_FARE: 'PRIME_FARE',
};
export const SIGN_MINUS = '-';
export const SIGN_PLUS = '+';
export const OFFERS = [
    OFFER_TYPES.PRIME_FARE,
    OFFER_TYPES.FULL_FARE,
];
export const EMPTY_STRING = '';
export const TRACKING = {
    CATEGORY: 'flights_ancillaries_page',
    DYNPACK_CATEGORY: 'dynpack_ancillaries_page',
    ACTIONS: {
        PRIME: 'prime',
        PRIME_SELECTION: 'prime_selection',
        TERMS_CONDITIONS: 'prime_terms_conditions',
        EXISTING_ACCOUNT: 'existing_account',
    },
};
export const REQUEST_FOR_RISKY_CC_TIMEOUT = 150;
